/**
 * Необходим для отслеживания изменений форм на странице, с последующим взаимодействием.
 * Инитим после того, как установили дефолтные значения в форме (html, js)
 * Например:
 *  1. Отрисовка кнопок сохранить и отменить, если в форме произошли какие-либо изменения
 *  2. Отрисовка кнопки назад, если изменений не было в форме и пользователь может вернуться обратно
 *
 * Как пользоваться:
 *  1. В своей форме добавьте аттрибут name
 *  2. Создайте в форме блок сохранить и отменить:
 * `<div class="actions-controller no-display"> <button class="actions-controller__reset">Отменить</button> <button class="actions-controller__submit"></button> </div>`
 * `<div class="actions-controller-back"> <button>Назад</button> </div>`
 *  3. Вызовите класс `new FormChangeTracker("FORMNAME")` вместо FORMNAME - имя формы, которое нужно отслеживать
 */
class FormChangeTracker {
  /**
   * Функция для инита дефолтных настроек для работой с изменениями в форме
   * @param {String | String[]} formName - Аттрибут для поиска формы или массив аттрибутов для поиска форм, которое нужно отслеживать
   */
  constructor(formName) {
    var self = this;

    if (!formName) throw new Error("Не указано имя формы");

    const formNames = Array.isArray(formName) ? formName : [formName];
    self.forms = self.getForms(formNames);
    if (!Object.keys(self.forms).length) throw new Error("Формы не найдены");

    self.currentFormFields = {}; // -> Текущие изменения в форме
    self.prevFormFields = {}; // -> Изначальные изменения в форме
    self.prevFormHtml = {}; // -> Изначальное html в форме
    var formNotChanged = {};
    self.formNotChanged = new Proxy(formNotChanged, {
      set: function(obj, prop, value) {
        obj[prop] = value;
        self.triggerFormNotChanged(prop);
        return true;
      },
    }); // -> Изменена ли форма
    self.initEventListers();
    Object.values(self.forms).map((form) => self.initForm(form[0]));
  }

  /**
   * Имена полей, которые не будут включены в список изменений
   * @property exceptFieldsName
   * @type {String[]}
   */
  exceptFieldsName = ["_method", "authenticity_token"];

  /**
   * Функция для получения всех форм на странице
   * @param {String[]} formNames - Имена форм для поиска по странице
   * @returns {{[formName: string]: JQuery<HTMLFormElement>}} - возвращает массив jQ форм
   */
  getForms(formNames) {
    formNames = formNames.filter((el) => el);

    /** @type {{[formName: string]: JQuery<HTMLFormElement>}} */
    const findForms = {};

    if (formNames.length) {
      formNames.map((formName) => {
        const findForm = $("body").find(`form[name="${formName}"]`);
        if (!findForm.length) return;

        findForms[formName] = findForm;
      });
    }

    return findForms;
  }

  /**
   * Функция для получения инпутов в форме
   * @param {HTMLFormElement} form - форма
   * @returns {{[key: string]: String | Number | File | Boolean}}
   */
  getFormInputs(form) {
    const self = this;
    /** @type {{[fieldName: string]: any}} */
    const currentFormFields = {};

    Array.from(form).map((field) => {
      const fieldName = field.name;
      // -> Если нет имени то поля, то пропускаем его
      if (!fieldName) return;

      // -> Если имя поля совпадает с исключительными именами полей, то пропускаем его
      if (self.exceptFieldsName.indexOf(fieldName) !== -1) return;

      if (field.type === "checkbox") return (currentFormFields[fieldName] = field.checked);

      if (field.type === "radio") {
        if (field.checked) currentFormFields[fieldName] = field.value;
        return;
      }

      if (field.type === "file") return (currentFormFields[fieldName] = field.files[0]);

      if (/\[\]/.test(fieldName)) {
        const nameField = fieldName.replace(/\[\]/, "");
        if (typeof currentFormFields[nameField] === "undefined") {
          currentFormFields[nameField] = [field.value];
        } else {
          currentFormFields[nameField].push(field.value);
        }
        return;
      }

      currentFormFields[fieldName] = field.value;
    });

    /** @type {{[fieldName: string]: any}} */
    const sortedCurrentFormFields = {};
    // Сортируем объект по ключам
    Object.keys(currentFormFields)
      .sort((a, b) => b - a)
      .forEach((v) => (sortedCurrentFormFields[v] = currentFormFields[v]));

    return sortedCurrentFormFields;
  }

  /**
   * Функция отслеживания прокси formNotChanged
   * @param {String} formName - Имя формы
   */
  triggerFormNotChanged(formName) {
    const self = this,
      changedForm = self.forms[formName];

    self.toggleBlockActionsController(changedForm, self.formNotChanged[formName]);
  }

  /**
   * Функция для скрытия/показа кнопок сохранить и отменить
   * @param {JQuery<HTMLFormElement>} form - Формы
   * @param {Boolean} state - Состояние показа
   */
  toggleBlockActionsController(form, state) {
    form.find(".actions-controller").toggleClass("no-display", state);
    form.find(".actions-controller-back").toggleClass("no-display", !state);
  }

  /** Функция для установки листнеров на формы */
  initEventListers() {
    const self = this;
    const formNames = Object.keys(self.forms);

    /**
     * Формирование селектора для поиска формы и селекторов в форме
     * @param {String=} selector - селектор для поиска
     * @returns {String}
     */
    const generateQuery = (selector) =>
      formNames.map((name) => `form[name='${name}']${selector ? ` ${selector}` : ""}`).join(", ");

    const arrFormEventListers = ["change", "input", "paste", "click"],
      queryFormEventListers = arrFormEventListers
        .map((lister) => `${lister}.handle${lister}CheckChangesForm`)
        .join(" ");

    $("body")
      .off(queryFormEventListers)
      .on(queryFormEventListers, generateQuery(), self.handleCheckChangesForm.bind(self));

    $("body")
      .off("click.handleClickResetForm")
      .on(
        "click.handleClickResetForm",
        generateQuery(".actions-controller .actions-controller__reset"),
        self.handleClickResetForm.bind(self)
      );
  }

  /**
   * Функция для инита настроек формы
   * @param {HTMLFormElement} form - Форма для инита
   */
  initForm(form) {
    var self = this;
    self.initFormChanges(form);
  }

  /**
   * Функция для инита изменений в форме
   * @param {HTMLFormElement} form - Форма для инита
   */
  initFormChanges(form) {
    const self = this,
      formName = form.name;
    if (!formName) return;

    self.prevFormFields[formName] = self.getFormInputs(form);
    self.prevFormHtml[formName] = form.innerHTML;
    self.formNotChanged[formName] = true;
  }

  /**
   * Хендлер исключения поля из проверки на изменение формы
   * @param {string[]} excludeFields - Массив названий полей, которые не нужно учитывать при изменении формы
   * @returns {boolean} Флаг исключения поля из проверки на изменение формы
   */
  excludeFieldForCheckChangesForm(excludeFields) {
    var hash = window.location.hash.replace(/^#/, "");

    return excludeFields.includes(hash);
  }

  /**
   * Хендлер на изменение формы
   * @private
   * @param {Event} event
   */
  handleCheckChangesForm(event) {
    if (this.excludeFieldForCheckChangesForm(["integrations"])) return;
    
    var self = this,
      targetForm = event.target.closest("form"),
      actionController = $(targetForm).find(".actions-controller");

    if (!actionController || !targetForm || !targetForm.name) return;

    self.checkChangesForm(targetForm.name, targetForm);
  }

  /**
   * Хендлер для ресета формы
   * @private
   * @param {Event} event
   */
  handleClickResetForm(event) {
    event.preventDefault();
    var self = this,
      parentForm = $(event.target).closest("form"),
      formName = parentForm[0].name;

    // Если есть имя формы и существует функция triggerResetFormChanges
    if (formName && typeof window.triggerResetFormChanges === "function") {
      parentForm[0].innerHTML = self.prevFormHtml[formName];
      window.triggerResetFormChanges(formName);
    } else {
      console.error("Нет функции window.triggerResetFormChanges");
      parentForm[0].reset();
      Array.from(parentForm[0]).map(function(el) {
        el = $(el);
        try {
          el.trigger("change");
          if (el && el.is("select") && el.hasClass("custom-select-input")) {
            var parent = el.closest(".custom-select"),
              findItem = parent.find(`.custom-select-el[data-custom-select-value="${el.val()}"]`);
            findItem.click();
          }
        } catch (e) {
          console.log(e);
        }
      });
    }

    parentForm.trigger("change");
  }

  /**
   * Функция для обновления изменений в форме
   * @param {String} formName - имя формы
   * @param {NodeElement} form - сама форма
   * @returns {Boolean} - возвращает изменилась ли форма
   */
  checkChangesForm(formName, form) {
    const self = this;

    self.currentFormFields[formName] = self.getFormInputs(form);
    self.formNotChanged[formName] =
      JSON.stringify(self.prevFormFields[formName]) === JSON.stringify(self.currentFormFields[formName]);
    return self.formNotChanged[formName];
  }
}

export default FormChangeTracker;
